const rewards_fr = require('./rewards.json')
export default rewards_fr